// @core/api/endpoints/search/list_search_indexes.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListSearchIndexesResponse,
} from '../../../types/search';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/search';

/**
 * List search indexes
 * Returns all search indexes configured on the platform. Supports filtering by product slug.
 */
export async function ListSearchIndexes(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListSearchIndexesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/search/indexes`;
  const requestOptions = options;
  return client.get<ListSearchIndexesResponse>(requestPath, { ...requestOptions, params });
}
